var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { keyframes } from '@emotion/react';
import { useTheme } from '../../../theme';
import { COLOR } from '../../../theme/colors';
export var SPINNER_SIZE;
(function (SPINNER_SIZE) {
    SPINNER_SIZE["SM"] = "sm";
    SPINNER_SIZE["MD"] = "md";
    SPINNER_SIZE["LG"] = "lg";
})(SPINNER_SIZE || (SPINNER_SIZE = {}));
const spin = keyframes({
    from: {
        transform: 'rotate(0deg)',
    },
    to: {
        transform: 'rotate(360deg)',
    },
});
const sizeLengthMap = {
    [SPINNER_SIZE.SM]: '1.25rem',
    [SPINNER_SIZE.MD]: '2rem',
    [SPINNER_SIZE.LG]: '3rem',
};
export const SPINNER_LABEL = 'Loading';
export const Spinner = (_a) => {
    var { size: sizeParam, color: colorParam } = _a, rest = __rest(_a, ["size", "color"]);
    const { colors } = useTheme();
    const size = sizeParam || SPINNER_SIZE.MD;
    const color = colors === null || colors === void 0 ? void 0 : colors[colorParam || COLOR.PRIMARY];
    return (_jsx("div", Object.assign({ "aria-label": SPINNER_LABEL, sx: {
            animation: `${spin} 1.4s linear 0s infinite normal none running;`,
            borderRadius: '50%',
            height: sizeLengthMap[size],
            width: sizeLengthMap[size],
            border: size === SPINNER_SIZE.LG ? 'solid 6px' : 'solid 4px',
            borderColor: `${color} ${color} transparent`,
        } }, rest)));
};
